import React from 'react';
import { motion } from 'framer-motion';
import { SacredGeometry } from './SacredGeometry';
export function Mechanism() {
  return <section className="w-full bg-white py-24 flex flex-col items-center" data-id="element-206">
      <div className="max-w-6xl mx-auto px-6 w-full mb-16" data-id="element-207">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl text-center mb-20" data-id="element-208">
          El campo energético como punto de acceso
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-209">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-6 text-lg text-gray-700 font-light leading-relaxed" data-id="element-210">
            <p data-id="element-211">
              Más allá del cuerpo físico, emocional y mental, existe un campo
              energético que registra todo — creencias, emociones, patrones
              heredados, programas del alma.
            </p>
            <p data-id="element-212">
              Cuando ese campo está denso o bloqueado, nada fluye con facilidad
              — sin importar cuánto trabajo consciente hayas realizado.
            </p>
            <p data-id="element-213">
              El Método Llave opera directamente en ese campo. No con
              suposiciones. No con protocolos genéricos. Con lo que tu campo
              muestra en el momento exacto del trabajo.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="flex justify-center items-center" data-id="element-214">
            <div className="w-64 h-64 md:w-80 md:h-80 relative" data-id="element-215">
              <SacredGeometry className="w-full h-full" color="#00A99D" data-id="element-216" />
            </div>
          </motion.div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="w-full bg-teal py-12 px-6" data-id="element-217">
        <p className="font-serif italic text-white text-xl md:text-2xl text-center max-w-4xl mx-auto leading-relaxed" data-id="element-218">
          "El péndulo hebreo no es solo una herramienta de lectura.
          <br data-id="element-219" />
          Es una herramienta de acción. Mueve energía real."
        </p>
      </motion.div>
    </section>;
}